import { render } from "./LeaveSetting.vue?vue&type=template&id=f85ed66a&scoped=true"
import script from "./LeaveSetting.vue?vue&type=script&lang=js"
export * from "./LeaveSetting.vue?vue&type=script&lang=js"

import "./LeaveSetting.vue?vue&type=style&index=0&id=f85ed66a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f85ed66a"]])

export default __exports__